
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "Activateable": [
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Supplier",
      "SupplierBranch",
      "Team",
      "TeamLicense",
      "Threat",
      "VerificationAction",
      "VerificationConfigurationRule"
    ],
    "AnalysisEntry": [
      "AnalysisReportEntry"
    ],
    "AnalysisEntryPredicate": [
      "QuestionPredicate",
      "Region",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "SupplierReliability",
      "VerificationPredicate"
    ],
    "AnalysisReportEntryRiskValue": [
      "AnalysisReportEntryProbability",
      "AnalysisReportEntryRiskLevel",
      "AnalysisReportEntrySeverity"
    ],
    "AnalysisReportEntryRiskValueOverwriteEvent": [
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent"
    ],
    "AnalysisReportWarning": [
      "AnalysisReportRiskConfigurationChangedWarning",
      "AnalysisReportVerificationConfigurationChangedWarning"
    ],
    "AttachTagsPayload": [
      "AttachTags_SuccessResult"
    ],
    "Audit": [
      "GeneralAudit",
      "ProductCategoryAudit",
      "RiskAudit",
      "RiskProbabilityAudit",
      "ThreatAudit",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit"
    ],
    "Commentable": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "AnalysisReportProductRisk",
      "Comment",
      "Company",
      "Contact",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "TeamLicense",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Connection": [
      "AccountConnection",
      "AnalysisReportConnection",
      "AnalysisReportEntryConnection",
      "AnalysisReportEntry_ProbabilityOverwriteEventConnection",
      "AnalysisReportEntry_SeverityOverwriteEventConnection",
      "AnalysisReportEntry_VerificationActionConnection",
      "AnalysisReportEntry_VerificationPredicateConnection",
      "AnalysisReportProductRiskConnection",
      "AnalysisReport_RiskConfigurationConnection",
      "CommentConnection",
      "CompanyConnection",
      "Company_ContactConnection",
      "ContactConnection",
      "FileConnection",
      "NotificationConnection",
      "ProductCategoryAuditConnection",
      "ProductCategoryConnection",
      "ProductCategory_RiskConnection",
      "ProductConnection",
      "ProductPredicateRequirementConnection",
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection",
      "Product_RiskConnection",
      "Query_CompanyConnection",
      "Query_CountryConnection",
      "Query_RegionConnection",
      "Query_RiskConfigurationConnection",
      "Query_SupplierReliabilityConnection",
      "Query_TeamConnection",
      "Query_VerificationActionConnection",
      "Query_VerificationConfigurationConnection",
      "QuestionPredicateConnection",
      "RegionConnection",
      "RiskAuditConnection",
      "RiskColumnConnection",
      "RiskColumn_RiskConnection",
      "RiskConfigurationConnection",
      "RiskConfigurationLevelConnection",
      "RiskConfigurationProbabilityConnection",
      "RiskConfigurationSeverityConnection",
      "RiskConfiguration_RiskConnection",
      "RiskConfiguration_ThreatConnection",
      "RiskConnection",
      "RiskProbabilityAuditConnection",
      "Risk_ProductCategoryConnection",
      "Risk_RiskColumnConnection",
      "Risk_RiskConfigurationConnection",
      "SupplierBranchConnection",
      "SupplierConnection",
      "SupplierReliabilityConnection",
      "TagConnection",
      "TeamConnection",
      "TeamLicenseClassConnection",
      "TeamLicenseConnection",
      "Team_ProductConnection",
      "Team_RiskConfigurationConnection",
      "Team_SupplierConnection",
      "Team_UserConnection",
      "Team_UserInvitationConnection",
      "Team_VerificationConfigurationConnection",
      "ThreatAuditConnection",
      "ThreatCategoryAuditConnection",
      "ThreatCategoryConnection",
      "ThreatConnection",
      "ThreatSeverityAuditConnection",
      "Threat_RiskConfigurationConnection",
      "UserConnection",
      "UserInvitationConnection",
      "UserInvitation_TeamConnection",
      "User_TeamConnection",
      "VerificationActionConnection",
      "VerificationConfigurationConnection",
      "VerificationConfigurationRuleConnection",
      "VerificationConfigurationRule_VerificationActionConnection",
      "VerificationConfiguration_VerificationActionConnection",
      "VerificationPredicateConnection"
    ],
    "ConnectionWithTotal": [
      "AccountConnection",
      "AnalysisReportConnection",
      "AnalysisReportEntryConnection",
      "AnalysisReportEntry_ProbabilityOverwriteEventConnection",
      "AnalysisReportEntry_SeverityOverwriteEventConnection",
      "AnalysisReportEntry_VerificationActionConnection",
      "AnalysisReportEntry_VerificationPredicateConnection",
      "AnalysisReportProductRiskConnection",
      "AnalysisReport_RiskConfigurationConnection",
      "CommentConnection",
      "CompanyConnection",
      "Company_ContactConnection",
      "ContactConnection",
      "NotificationConnection",
      "ProductCategoryAuditConnection",
      "ProductCategoryConnection",
      "ProductCategory_RiskConnection",
      "ProductConnection",
      "ProductPredicateRequirementConnection",
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection",
      "Product_RiskConnection",
      "Query_CompanyConnection",
      "Query_CountryConnection",
      "Query_RegionConnection",
      "Query_RiskConfigurationConnection",
      "Query_SupplierReliabilityConnection",
      "Query_TeamConnection",
      "Query_VerificationActionConnection",
      "Query_VerificationConfigurationConnection",
      "QuestionPredicateConnection",
      "RegionConnection",
      "RiskAuditConnection",
      "RiskColumnConnection",
      "RiskColumn_RiskConnection",
      "RiskConfigurationConnection",
      "RiskConfigurationLevelConnection",
      "RiskConfigurationProbabilityConnection",
      "RiskConfigurationSeverityConnection",
      "RiskConfiguration_RiskConnection",
      "RiskConfiguration_ThreatConnection",
      "RiskConnection",
      "RiskProbabilityAuditConnection",
      "Risk_ProductCategoryConnection",
      "Risk_RiskColumnConnection",
      "Risk_RiskConfigurationConnection",
      "SupplierBranchConnection",
      "SupplierConnection",
      "SupplierReliabilityConnection",
      "TagConnection",
      "TeamConnection",
      "TeamLicenseClassConnection",
      "TeamLicenseConnection",
      "Team_ProductConnection",
      "Team_RiskConfigurationConnection",
      "Team_SupplierConnection",
      "Team_UserConnection",
      "Team_UserInvitationConnection",
      "Team_VerificationConfigurationConnection",
      "ThreatAuditConnection",
      "ThreatCategoryAuditConnection",
      "ThreatCategoryConnection",
      "ThreatConnection",
      "ThreatSeverityAuditConnection",
      "Threat_RiskConfigurationConnection",
      "UserInvitationConnection",
      "UserInvitation_TeamConnection",
      "User_TeamConnection",
      "VerificationActionConnection",
      "VerificationConfigurationConnection",
      "VerificationConfigurationRuleConnection",
      "VerificationConfigurationRule_VerificationActionConnection",
      "VerificationConfiguration_VerificationActionConnection",
      "VerificationPredicateConnection"
    ],
    "CreateTagPayload": [
      "CreateTag_SuccessResult"
    ],
    "DetachTagsPayload": [
      "DetachTags_SuccessResult"
    ],
    "Edge": [
      "AccountEdge",
      "AnalysisReportEdge",
      "AnalysisReportEntryEdge",
      "AnalysisReportEntry_ProbabilityOverwriteEventEdge",
      "AnalysisReportEntry_SeverityOverwriteEventEdge",
      "AnalysisReportEntry_VerificationActionEdge",
      "AnalysisReportEntry_VerificationPredicateEdge",
      "AnalysisReportProductRiskEdge",
      "AnalysisReport_RiskConfigurationEdge",
      "CommentEdge",
      "CompanyEdge",
      "Company_ContactEdge",
      "ContactEdge",
      "CountryEdge",
      "FileEdge",
      "NotificationEdge",
      "ProductCategoryAuditEdge",
      "ProductCategoryEdge",
      "ProductCategory_RiskEdge",
      "ProductEdge",
      "ProductPredicateRequirementEdge",
      "Product_QuestionPredicateEdge",
      "Product_RegionEdge",
      "Product_RiskEdge",
      "QuestionPredicateEdge",
      "RegionEdge",
      "RiskAuditEdge",
      "RiskColumnEdge",
      "RiskColumn_RiskEdge",
      "RiskConfigurationEdge",
      "RiskConfigurationLevelEdge",
      "RiskConfigurationProbabilityEdge",
      "RiskConfigurationSeverityEdge",
      "RiskConfiguration_RiskEdge",
      "RiskConfiguration_ThreatEdge",
      "RiskEdge",
      "RiskProbabilityAuditEdge",
      "Risk_ProductCategoryEdge",
      "Risk_RiskColumnEdge",
      "Risk_RiskConfigurationEdge",
      "SupplierBranchEdge",
      "SupplierEdge",
      "SupplierReliabilityEdge",
      "TagEdge",
      "TeamEdge",
      "TeamLicenseClassEdge",
      "TeamLicenseEdge",
      "Team_ProductEdge",
      "Team_RiskConfigurationEdge",
      "Team_SupplierEdge",
      "Team_UserEdge",
      "Team_UserInvitationEdge",
      "Team_VerificationConfigurationEdge",
      "ThreatAuditEdge",
      "ThreatCategoryAuditEdge",
      "ThreatCategoryEdge",
      "ThreatEdge",
      "ThreatSeverityAuditEdge",
      "Threat_RiskConfigurationEdge",
      "UserEdge",
      "UserInvitationEdge",
      "UserInvitation_TeamEdge",
      "User_TeamEdge",
      "VerificationActionEdge",
      "VerificationConfigurationEdge",
      "VerificationConfigurationRuleEdge",
      "VerificationConfigurationRule_VerificationActionEdge",
      "VerificationConfiguration_VerificationActionEdge",
      "VerificationPredicateEdge"
    ],
    "EntityName": [
      "ContactName",
      "Name",
      "UserName"
    ],
    "Exception": [
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException"
    ],
    "FileUploadRequest": [
      "AzureBlobStorageFileUploadRequest",
      "GenericFileUploadRequest"
    ],
    "GenerateAnalysisReportPayload": [
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException",
      "GenerateAnalysisReport_SuccessResult"
    ],
    "HasFiles": [
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob"
    ],
    "Hashed": [
      "AnalysisEntryPredicateExpression",
      "ProductPredicateExpression"
    ],
    "Job": [
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob"
    ],
    "MutationPayload": [
      "ActivateMany_SuccessResult",
      "Activate_SuccessResult",
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException",
      "AssignTeamRole_SuccessResult",
      "AssignTeamRoles_SuccessResult",
      "AssignUserRole_SuccessResult",
      "AssignUserRoles_SuccessResult",
      "AttachTags_SuccessResult",
      "CancelUserInvitation_SuccessResult",
      "ClearAnalysisReportEntries_SuccessResult",
      "ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult",
      "ClearAnalysisReportProductRisks_SuccessResult",
      "ClearAnalysisReportProducts_SuccessResult",
      "ClearAnalysisReportRiskConfigurations_SuccessResult",
      "CreateAnalysisReport_SuccessResult",
      "CreateComment_SuccessResult",
      "CreateCompany_SuccessResult",
      "CreateContact_SuccessResult",
      "CreateMeiliSearch_SuccessResult",
      "CreateProductCategory_SuccessResult",
      "CreateProduct_SuccessResult",
      "CreateQuestionPredicate_SuccessResult",
      "CreateRegion_SuccessResult",
      "CreateRiskColumn_SuccessResult",
      "CreateRiskConfiguration_SuccessResult",
      "CreateRisk_SuccessResult",
      "CreateSupplierBranch_SuccessResult",
      "CreateSupplier_SuccessResult",
      "CreateTag_SuccessResult",
      "CreateTeamLicenseClass_SuccessResult",
      "CreateTeamLicense_SuccessResult",
      "CreateTeam_SuccessResult",
      "CreateThreatCategory_SuccessResult",
      "CreateThreat_SuccessResult",
      "CreateUserInvitation_SuccessResult",
      "CreateUser_SuccessResult",
      "CreateVerificationAction_SuccessResult",
      "CreateVerificationConfiguration_SuccessResult",
      "CreateVerificationPredicate_SuccessResult",
      "DeactivateMany_SuccessResult",
      "Deactivate_SuccessResult",
      "Delete_SuccessResult",
      "DetachTags_SuccessResult",
      "ForceDelete_SuccessResult",
      "GenerateAnalysisReport_SuccessResult",
      "RebuildSearchIndexes_SuccessResult",
      "Restore_SuccessResult",
      "RetractTeamRole_SuccessResult",
      "RetractTeamRoles_SuccessResult",
      "RetractUserRole_SuccessResult",
      "RetractUserRoles_SuccessResult",
      "SendNotification_SuccessResult",
      "SendUserInvitation_SuccessResult",
      "UpdateAnalysisReportEntry_SuccessResult",
      "UpdateAnalysisReportProductRisk_SuccessResult",
      "UpdateAnalysisReportProductRisks_SuccessResult",
      "UpdateAnalysisReport_SuccessResult",
      "UpdateAudit_SuccessResult",
      "UpdateAudits_SuccessResult",
      "UpdateComment_SuccessResult",
      "UpdateComments_SuccessResult",
      "UpdateCompanies_SuccessResult",
      "UpdateCompany_SuccessResult",
      "UpdateContact_SuccessResult",
      "UpdateContacts_SuccessResult",
      "UpdateProductCategory_SuccessResult",
      "UpdateProduct_SuccessResult",
      "UpdateProducts_SuccessResult",
      "UpdateQuestionPredicate_SuccessResult",
      "UpdateRegion_SuccessResult",
      "UpdateRiskColumn_SuccessResult",
      "UpdateRiskConfiguration_SuccessResult",
      "UpdateRisks_SuccessResult",
      "UpdateSupplierBranch_SuccessResult",
      "UpdateSupplierBranches_SuccessResult",
      "UpdateSupplier_SuccessResult",
      "UpdateSuppliers_SuccessResult",
      "UpdateTag_SuccessResult",
      "UpdateTeamLicenseClass_SuccessResult",
      "UpdateTeamLicense_SuccessResult",
      "UpdateTeam_SuccessResult",
      "UpdateTeams_SuccessResult",
      "UpdateThreatCategory_SuccessResult",
      "UpdateThreat_SuccessResult",
      "UpdateThreats_SuccessResult",
      "UpdateUserInvitation_SuccessResult",
      "UpdateUser_SuccessResult",
      "UpdateUsers_SuccessResult",
      "UpdateVerificationAction_SuccessResult",
      "UpdateVerificationConfigurationRule_SuccessResult",
      "UpdateVerificationConfiguration_SuccessResult",
      "UpdateVerificationPredicate_SuccessResult",
      "UploadFile_SuccessResult"
    ],
    "Named": [
      "AnalysisReport",
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicenseClass",
      "Threat",
      "ThreatCategory",
      "User",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "NestedSetConnection": [
      "ProductCategoryConnection",
      "ThreatCategoryConnection"
    ],
    "NestedSetEdge": [
      "ProductCategoryEdge",
      "ThreatCategoryEdge"
    ],
    "NestedSetNode": [
      "ProductCategory",
      "ThreatCategory"
    ],
    "Node": [
      "AddressFormat",
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "AnalysisReportProductRisk",
      "AssignProductCategoryToProductTodo",
      "AssignSupplierBranchToProductTodo",
      "Client",
      "Comment",
      "Company",
      "Contact",
      "Country",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "File",
      "GeneralAudit",
      "Notification",
      "PhoneNumberFormat",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "ProductPredicateRequirement",
      "ProvideRequiredProductPredicateValuesTodo",
      "QuestionPredicate",
      "Region",
      "ResolveAnalysisReportProductRiskPredicateValueTodo",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "RiskProbabilityAudit",
      "SelectAnalysisReportProductsTodo",
      "SetRiskProbabilityValueForRiskConfigurationTodo",
      "SetThreatSeverityValueForRiskConfigurationTodo",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "User",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Notifiable": [
      "Team"
    ],
    "Ownable": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportProductRisk",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Owner": [
      "Team"
    ],
    "PersonName": [
      "ContactName"
    ],
    "PersonNameHonorific": [
      "ContactNameHonorific"
    ],
    "PersonNameLast": [
      "ContactNameLast"
    ],
    "Predicate": [
      "QuestionPredicate",
      "Region",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "SupplierReliability",
      "VerificationPredicate"
    ],
    "PredicateExpression": [
      "AnalysisEntryPredicateExpression",
      "ProductPredicateExpression"
    ],
    "PredicateProductConnection": [],
    "PredicateProductEdge": [],
    "PredicateRequirement": [],
    "PredicateRiskConnection": [],
    "PredicateRiskEdge": [],
    "ProductPredicate": [
      "QuestionPredicate",
      "Region"
    ],
    "ProductPredicateConnection": [
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection"
    ],
    "ProductPredicateEdge": [
      "Product_PredicateEdge",
      "Product_QuestionPredicateEdge",
      "Product_RegionEdge"
    ],
    "RiskConfigurationSegment": [
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity"
    ],
    "RiskValue": [
      "RiskLevel",
      "RiskProbability",
      "RiskSeverity"
    ],
    "Selectable": [
      "AnalysisReport",
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicenseClass",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Sluggable": [
      "Company",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Team",
      "Threat",
      "VerificationAction",
      "VerificationConfiguration"
    ],
    "SoftDelete": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationPredicate"
    ],
    "SoftDeleteUserstamped": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationPredicate"
    ],
    "Taggable": [
      "AnalysisReport",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "Company",
      "Contact",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Timestamped": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "Comment",
      "Company",
      "Contact",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "File",
      "GeneralAudit",
      "Notification",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Todo": [
      "AssignProductCategoryToProductTodo",
      "AssignSupplierBranchToProductTodo",
      "ProvideRequiredProductPredicateValuesTodo",
      "ResolveAnalysisReportProductRiskPredicateValueTodo",
      "SelectAnalysisReportProductsTodo",
      "SetRiskProbabilityValueForRiskConfigurationTodo",
      "SetThreatSeverityValueForRiskConfigurationTodo"
    ],
    "UpdateTagPayload": [
      "UpdateTag_SuccessResult"
    ],
    "Usable": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Userstamped": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "Comment",
      "Company",
      "Contact",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Warning": [
      "AnalysisReportRiskConfigurationChangedWarning",
      "AnalysisReportVerificationConfigurationChangedWarning"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Activateable": [
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Supplier",
      "SupplierBranch",
      "Team",
      "TeamLicense",
      "Threat",
      "VerificationAction",
      "VerificationConfigurationRule"
    ],
    "AnalysisEntry": [
      "AnalysisReportEntry"
    ],
    "AnalysisEntryPredicate": [
      "QuestionPredicate",
      "Region",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "SupplierReliability",
      "VerificationPredicate"
    ],
    "AnalysisReportEntryRiskValue": [
      "AnalysisReportEntryProbability",
      "AnalysisReportEntryRiskLevel",
      "AnalysisReportEntrySeverity"
    ],
    "AnalysisReportEntryRiskValueOverwriteEvent": [
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent"
    ],
    "AnalysisReportWarning": [
      "AnalysisReportRiskConfigurationChangedWarning",
      "AnalysisReportVerificationConfigurationChangedWarning"
    ],
    "AttachTagsPayload": [
      "AttachTags_SuccessResult"
    ],
    "Audit": [
      "GeneralAudit",
      "ProductCategoryAudit",
      "RiskAudit",
      "RiskProbabilityAudit",
      "ThreatAudit",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit"
    ],
    "Commentable": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "AnalysisReportProductRisk",
      "Comment",
      "Company",
      "Contact",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "TeamLicense",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Connection": [
      "AccountConnection",
      "AnalysisReportConnection",
      "AnalysisReportEntryConnection",
      "AnalysisReportEntry_ProbabilityOverwriteEventConnection",
      "AnalysisReportEntry_SeverityOverwriteEventConnection",
      "AnalysisReportEntry_VerificationActionConnection",
      "AnalysisReportEntry_VerificationPredicateConnection",
      "AnalysisReportProductRiskConnection",
      "AnalysisReport_RiskConfigurationConnection",
      "CommentConnection",
      "CompanyConnection",
      "Company_ContactConnection",
      "ContactConnection",
      "FileConnection",
      "NotificationConnection",
      "ProductCategoryAuditConnection",
      "ProductCategoryConnection",
      "ProductCategory_RiskConnection",
      "ProductConnection",
      "ProductPredicateRequirementConnection",
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection",
      "Product_RiskConnection",
      "Query_CompanyConnection",
      "Query_CountryConnection",
      "Query_RegionConnection",
      "Query_RiskConfigurationConnection",
      "Query_SupplierReliabilityConnection",
      "Query_TeamConnection",
      "Query_VerificationActionConnection",
      "Query_VerificationConfigurationConnection",
      "QuestionPredicateConnection",
      "RegionConnection",
      "RiskAuditConnection",
      "RiskColumnConnection",
      "RiskColumn_RiskConnection",
      "RiskConfigurationConnection",
      "RiskConfigurationLevelConnection",
      "RiskConfigurationProbabilityConnection",
      "RiskConfigurationSeverityConnection",
      "RiskConfiguration_RiskConnection",
      "RiskConfiguration_ThreatConnection",
      "RiskConnection",
      "RiskProbabilityAuditConnection",
      "Risk_ProductCategoryConnection",
      "Risk_RiskColumnConnection",
      "Risk_RiskConfigurationConnection",
      "SupplierBranchConnection",
      "SupplierConnection",
      "SupplierReliabilityConnection",
      "TagConnection",
      "TeamConnection",
      "TeamLicenseClassConnection",
      "TeamLicenseConnection",
      "Team_ProductConnection",
      "Team_RiskConfigurationConnection",
      "Team_SupplierConnection",
      "Team_UserConnection",
      "Team_UserInvitationConnection",
      "Team_VerificationConfigurationConnection",
      "ThreatAuditConnection",
      "ThreatCategoryAuditConnection",
      "ThreatCategoryConnection",
      "ThreatConnection",
      "ThreatSeverityAuditConnection",
      "Threat_RiskConfigurationConnection",
      "UserConnection",
      "UserInvitationConnection",
      "UserInvitation_TeamConnection",
      "User_TeamConnection",
      "VerificationActionConnection",
      "VerificationConfigurationConnection",
      "VerificationConfigurationRuleConnection",
      "VerificationConfigurationRule_VerificationActionConnection",
      "VerificationConfiguration_VerificationActionConnection",
      "VerificationPredicateConnection"
    ],
    "ConnectionWithTotal": [
      "AccountConnection",
      "AnalysisReportConnection",
      "AnalysisReportEntryConnection",
      "AnalysisReportEntry_ProbabilityOverwriteEventConnection",
      "AnalysisReportEntry_SeverityOverwriteEventConnection",
      "AnalysisReportEntry_VerificationActionConnection",
      "AnalysisReportEntry_VerificationPredicateConnection",
      "AnalysisReportProductRiskConnection",
      "AnalysisReport_RiskConfigurationConnection",
      "CommentConnection",
      "CompanyConnection",
      "Company_ContactConnection",
      "ContactConnection",
      "NotificationConnection",
      "ProductCategoryAuditConnection",
      "ProductCategoryConnection",
      "ProductCategory_RiskConnection",
      "ProductConnection",
      "ProductPredicateRequirementConnection",
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection",
      "Product_RiskConnection",
      "Query_CompanyConnection",
      "Query_CountryConnection",
      "Query_RegionConnection",
      "Query_RiskConfigurationConnection",
      "Query_SupplierReliabilityConnection",
      "Query_TeamConnection",
      "Query_VerificationActionConnection",
      "Query_VerificationConfigurationConnection",
      "QuestionPredicateConnection",
      "RegionConnection",
      "RiskAuditConnection",
      "RiskColumnConnection",
      "RiskColumn_RiskConnection",
      "RiskConfigurationConnection",
      "RiskConfigurationLevelConnection",
      "RiskConfigurationProbabilityConnection",
      "RiskConfigurationSeverityConnection",
      "RiskConfiguration_RiskConnection",
      "RiskConfiguration_ThreatConnection",
      "RiskConnection",
      "RiskProbabilityAuditConnection",
      "Risk_ProductCategoryConnection",
      "Risk_RiskColumnConnection",
      "Risk_RiskConfigurationConnection",
      "SupplierBranchConnection",
      "SupplierConnection",
      "SupplierReliabilityConnection",
      "TagConnection",
      "TeamConnection",
      "TeamLicenseClassConnection",
      "TeamLicenseConnection",
      "Team_ProductConnection",
      "Team_RiskConfigurationConnection",
      "Team_SupplierConnection",
      "Team_UserConnection",
      "Team_UserInvitationConnection",
      "Team_VerificationConfigurationConnection",
      "ThreatAuditConnection",
      "ThreatCategoryAuditConnection",
      "ThreatCategoryConnection",
      "ThreatConnection",
      "ThreatSeverityAuditConnection",
      "Threat_RiskConfigurationConnection",
      "UserInvitationConnection",
      "UserInvitation_TeamConnection",
      "User_TeamConnection",
      "VerificationActionConnection",
      "VerificationConfigurationConnection",
      "VerificationConfigurationRuleConnection",
      "VerificationConfigurationRule_VerificationActionConnection",
      "VerificationConfiguration_VerificationActionConnection",
      "VerificationPredicateConnection"
    ],
    "CreateTagPayload": [
      "CreateTag_SuccessResult"
    ],
    "DetachTagsPayload": [
      "DetachTags_SuccessResult"
    ],
    "Edge": [
      "AccountEdge",
      "AnalysisReportEdge",
      "AnalysisReportEntryEdge",
      "AnalysisReportEntry_ProbabilityOverwriteEventEdge",
      "AnalysisReportEntry_SeverityOverwriteEventEdge",
      "AnalysisReportEntry_VerificationActionEdge",
      "AnalysisReportEntry_VerificationPredicateEdge",
      "AnalysisReportProductRiskEdge",
      "AnalysisReport_RiskConfigurationEdge",
      "CommentEdge",
      "CompanyEdge",
      "Company_ContactEdge",
      "ContactEdge",
      "CountryEdge",
      "FileEdge",
      "NotificationEdge",
      "ProductCategoryAuditEdge",
      "ProductCategoryEdge",
      "ProductCategory_RiskEdge",
      "ProductEdge",
      "ProductPredicateRequirementEdge",
      "Product_QuestionPredicateEdge",
      "Product_RegionEdge",
      "Product_RiskEdge",
      "QuestionPredicateEdge",
      "RegionEdge",
      "RiskAuditEdge",
      "RiskColumnEdge",
      "RiskColumn_RiskEdge",
      "RiskConfigurationEdge",
      "RiskConfigurationLevelEdge",
      "RiskConfigurationProbabilityEdge",
      "RiskConfigurationSeverityEdge",
      "RiskConfiguration_RiskEdge",
      "RiskConfiguration_ThreatEdge",
      "RiskEdge",
      "RiskProbabilityAuditEdge",
      "Risk_ProductCategoryEdge",
      "Risk_RiskColumnEdge",
      "Risk_RiskConfigurationEdge",
      "SupplierBranchEdge",
      "SupplierEdge",
      "SupplierReliabilityEdge",
      "TagEdge",
      "TeamEdge",
      "TeamLicenseClassEdge",
      "TeamLicenseEdge",
      "Team_ProductEdge",
      "Team_RiskConfigurationEdge",
      "Team_SupplierEdge",
      "Team_UserEdge",
      "Team_UserInvitationEdge",
      "Team_VerificationConfigurationEdge",
      "ThreatAuditEdge",
      "ThreatCategoryAuditEdge",
      "ThreatCategoryEdge",
      "ThreatEdge",
      "ThreatSeverityAuditEdge",
      "Threat_RiskConfigurationEdge",
      "UserEdge",
      "UserInvitationEdge",
      "UserInvitation_TeamEdge",
      "User_TeamEdge",
      "VerificationActionEdge",
      "VerificationConfigurationEdge",
      "VerificationConfigurationRuleEdge",
      "VerificationConfigurationRule_VerificationActionEdge",
      "VerificationConfiguration_VerificationActionEdge",
      "VerificationPredicateEdge"
    ],
    "EntityName": [
      "ContactName",
      "Name",
      "UserName"
    ],
    "Exception": [
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException"
    ],
    "FileUploadRequest": [
      "AzureBlobStorageFileUploadRequest",
      "GenericFileUploadRequest"
    ],
    "GenerateAnalysisReportPayload": [
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException",
      "GenerateAnalysisReport_SuccessResult"
    ],
    "HasFiles": [
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob"
    ],
    "Hashed": [
      "AnalysisEntryPredicateExpression",
      "ProductPredicateExpression"
    ],
    "Job": [
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob"
    ],
    "MutationPayload": [
      "ActivateMany_SuccessResult",
      "Activate_SuccessResult",
      "AnalysisReportInvalidStateException",
      "AnalysisReportTodoListNotEmptyException",
      "AssignTeamRole_SuccessResult",
      "AssignTeamRoles_SuccessResult",
      "AssignUserRole_SuccessResult",
      "AssignUserRoles_SuccessResult",
      "AttachTags_SuccessResult",
      "CancelUserInvitation_SuccessResult",
      "ClearAnalysisReportEntries_SuccessResult",
      "ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult",
      "ClearAnalysisReportProductRisks_SuccessResult",
      "ClearAnalysisReportProducts_SuccessResult",
      "ClearAnalysisReportRiskConfigurations_SuccessResult",
      "CreateAnalysisReport_SuccessResult",
      "CreateComment_SuccessResult",
      "CreateCompany_SuccessResult",
      "CreateContact_SuccessResult",
      "CreateMeiliSearch_SuccessResult",
      "CreateProductCategory_SuccessResult",
      "CreateProduct_SuccessResult",
      "CreateQuestionPredicate_SuccessResult",
      "CreateRegion_SuccessResult",
      "CreateRiskColumn_SuccessResult",
      "CreateRiskConfiguration_SuccessResult",
      "CreateRisk_SuccessResult",
      "CreateSupplierBranch_SuccessResult",
      "CreateSupplier_SuccessResult",
      "CreateTag_SuccessResult",
      "CreateTeamLicenseClass_SuccessResult",
      "CreateTeamLicense_SuccessResult",
      "CreateTeam_SuccessResult",
      "CreateThreatCategory_SuccessResult",
      "CreateThreat_SuccessResult",
      "CreateUserInvitation_SuccessResult",
      "CreateUser_SuccessResult",
      "CreateVerificationAction_SuccessResult",
      "CreateVerificationConfiguration_SuccessResult",
      "CreateVerificationPredicate_SuccessResult",
      "DeactivateMany_SuccessResult",
      "Deactivate_SuccessResult",
      "Delete_SuccessResult",
      "DetachTags_SuccessResult",
      "ForceDelete_SuccessResult",
      "GenerateAnalysisReport_SuccessResult",
      "RebuildSearchIndexes_SuccessResult",
      "Restore_SuccessResult",
      "RetractTeamRole_SuccessResult",
      "RetractTeamRoles_SuccessResult",
      "RetractUserRole_SuccessResult",
      "RetractUserRoles_SuccessResult",
      "SendNotification_SuccessResult",
      "SendUserInvitation_SuccessResult",
      "UpdateAnalysisReportEntry_SuccessResult",
      "UpdateAnalysisReportProductRisk_SuccessResult",
      "UpdateAnalysisReportProductRisks_SuccessResult",
      "UpdateAnalysisReport_SuccessResult",
      "UpdateAudit_SuccessResult",
      "UpdateAudits_SuccessResult",
      "UpdateComment_SuccessResult",
      "UpdateComments_SuccessResult",
      "UpdateCompanies_SuccessResult",
      "UpdateCompany_SuccessResult",
      "UpdateContact_SuccessResult",
      "UpdateContacts_SuccessResult",
      "UpdateProductCategory_SuccessResult",
      "UpdateProduct_SuccessResult",
      "UpdateProducts_SuccessResult",
      "UpdateQuestionPredicate_SuccessResult",
      "UpdateRegion_SuccessResult",
      "UpdateRiskColumn_SuccessResult",
      "UpdateRiskConfiguration_SuccessResult",
      "UpdateRisks_SuccessResult",
      "UpdateSupplierBranch_SuccessResult",
      "UpdateSupplierBranches_SuccessResult",
      "UpdateSupplier_SuccessResult",
      "UpdateSuppliers_SuccessResult",
      "UpdateTag_SuccessResult",
      "UpdateTeamLicenseClass_SuccessResult",
      "UpdateTeamLicense_SuccessResult",
      "UpdateTeam_SuccessResult",
      "UpdateTeams_SuccessResult",
      "UpdateThreatCategory_SuccessResult",
      "UpdateThreat_SuccessResult",
      "UpdateThreats_SuccessResult",
      "UpdateUserInvitation_SuccessResult",
      "UpdateUser_SuccessResult",
      "UpdateUsers_SuccessResult",
      "UpdateVerificationAction_SuccessResult",
      "UpdateVerificationConfigurationRule_SuccessResult",
      "UpdateVerificationConfiguration_SuccessResult",
      "UpdateVerificationPredicate_SuccessResult",
      "UploadFile_SuccessResult"
    ],
    "Named": [
      "AnalysisReport",
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicenseClass",
      "Threat",
      "ThreatCategory",
      "User",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "NestedSetConnection": [
      "ProductCategoryConnection",
      "ThreatCategoryConnection"
    ],
    "NestedSetEdge": [
      "ProductCategoryEdge",
      "ThreatCategoryEdge"
    ],
    "NestedSetNode": [
      "ProductCategory",
      "ThreatCategory"
    ],
    "Node": [
      "AddressFormat",
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "AnalysisReportProductRisk",
      "AssignProductCategoryToProductTodo",
      "AssignSupplierBranchToProductTodo",
      "Client",
      "Comment",
      "Company",
      "Contact",
      "Country",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "File",
      "GeneralAudit",
      "Notification",
      "PhoneNumberFormat",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "ProductPredicateRequirement",
      "ProvideRequiredProductPredicateValuesTodo",
      "QuestionPredicate",
      "Region",
      "ResolveAnalysisReportProductRiskPredicateValueTodo",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "RiskProbabilityAudit",
      "SelectAnalysisReportProductsTodo",
      "SetRiskProbabilityValueForRiskConfigurationTodo",
      "SetThreatSeverityValueForRiskConfigurationTodo",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "User",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Notifiable": [
      "Team"
    ],
    "Ownable": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportProductRisk",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Owner": [
      "Team"
    ],
    "PersonName": [
      "ContactName"
    ],
    "PersonNameHonorific": [
      "ContactNameHonorific"
    ],
    "PersonNameLast": [
      "ContactNameLast"
    ],
    "Predicate": [
      "QuestionPredicate",
      "Region",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "SupplierReliability",
      "VerificationPredicate"
    ],
    "PredicateExpression": [
      "AnalysisEntryPredicateExpression",
      "ProductPredicateExpression"
    ],
    "PredicateProductConnection": [],
    "PredicateProductEdge": [],
    "PredicateRequirement": [],
    "PredicateRiskConnection": [],
    "PredicateRiskEdge": [],
    "ProductPredicate": [
      "QuestionPredicate",
      "Region"
    ],
    "ProductPredicateConnection": [
      "Product_QuestionPredicateConnection",
      "Product_RegionConnection"
    ],
    "ProductPredicateEdge": [
      "Product_PredicateEdge",
      "Product_QuestionPredicateEdge",
      "Product_RegionEdge"
    ],
    "RiskConfigurationSegment": [
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity"
    ],
    "RiskValue": [
      "RiskLevel",
      "RiskProbability",
      "RiskSeverity"
    ],
    "Selectable": [
      "AnalysisReport",
      "Company",
      "Contact",
      "Product",
      "ProductCategory",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Team",
      "TeamLicenseClass",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Sluggable": [
      "Company",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Team",
      "Threat",
      "VerificationAction",
      "VerificationConfiguration"
    ],
    "SoftDelete": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationPredicate"
    ],
    "SoftDeleteUserstamped": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskConfiguration",
      "Supplier",
      "SupplierBranch",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationPredicate"
    ],
    "Taggable": [
      "AnalysisReport",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "Company",
      "Contact",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Timestamped": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "AnalysisReportEntryProbabilityOverwriteEvent",
      "AnalysisReportEntrySeverityOverwriteEvent",
      "Comment",
      "Company",
      "Contact",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "File",
      "GeneralAudit",
      "Notification",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Todo": [
      "AssignProductCategoryToProductTodo",
      "AssignSupplierBranchToProductTodo",
      "ProvideRequiredProductPredicateValuesTodo",
      "ResolveAnalysisReportProductRiskPredicateValueTodo",
      "SelectAnalysisReportProductsTodo",
      "SetRiskProbabilityValueForRiskConfigurationTodo",
      "SetThreatSeverityValueForRiskConfigurationTodo"
    ],
    "UpdateTagPayload": [
      "UpdateTag_SuccessResult"
    ],
    "Usable": [
      "Product",
      "ProductCategory",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskColumn",
      "RiskConfiguration",
      "RiskConfigurationLevel",
      "RiskConfigurationProbability",
      "RiskConfigurationSeverity",
      "Supplier",
      "SupplierBranch",
      "SupplierReliability",
      "Tag",
      "Threat",
      "ThreatCategory",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Userstamped": [
      "AnalysisReport",
      "AnalysisReportEntry",
      "Comment",
      "Company",
      "Contact",
      "EchoFilesJob",
      "ExportAnalysisReportEntriesJob",
      "ExportProductsSpreadsheetJob",
      "ExportSupplierBranchesSpreadsheetJob",
      "ExportSupplierVCardsJob",
      "ExportSuppliersSpreadsheetJob",
      "GeneralAudit",
      "Product",
      "ProductCategory",
      "ProductCategoryAudit",
      "QuestionPredicate",
      "Region",
      "Risk",
      "RiskAudit",
      "RiskColumn",
      "RiskConfiguration",
      "RiskProbabilityAudit",
      "Supplier",
      "SupplierBranch",
      "Tag",
      "Team",
      "TeamLicense",
      "TeamLicenseClass",
      "Threat",
      "ThreatAudit",
      "ThreatCategory",
      "ThreatCategoryAudit",
      "ThreatSeverityAudit",
      "UserInvitation",
      "VerificationAction",
      "VerificationConfiguration",
      "VerificationConfigurationRule",
      "VerificationPredicate"
    ],
    "Warning": [
      "AnalysisReportRiskConfigurationChangedWarning",
      "AnalysisReportVerificationConfigurationChangedWarning"
    ]
  }
};
      export default result;
    